<mat-card class="{{ level }} mat-elevation-z0" [style.max-width]="maxWidth" [class.minimal]="singleLine">
  <mat-card-content>
    @if (singleLine) {
      <div class="single-line" [style.padding]="singleLinePadding">
        <div class="single-line-title">
          <mat-icon inline>{{ level }}</mat-icon>
          @if (!hideTitle) {
            <span>{{ title || (level | titlecase) | translate: locale.language }}:</span>
          }
        </div>
        <span>{{ message | translate: locale.language }}</span>
      </div>
    } @else {
      @if (!hideTitle) {
        <div class="info-card-title">
          <mat-icon>{{ level }}</mat-icon>
          <div>{{ title || (level | titlecase) | translate: locale.language }}</div>
        </div>
      }
      @if (message) {
        {{ message | translate: locale.language }}
      }
      @if (messages?.length) {
        <ul class="info-messages">
          @for (message of messages; track message) {
            <li>{{ message | translate: locale.language }}</li>
          }
        </ul>
      }
    }
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
